import { render } from "./ConfirmationOfCancellationModal.vue?vue&type=template&id=7402b8a1&scoped=true"
import script from "./ConfirmationOfCancellationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationOfCancellationModal.vue?vue&type=script&lang=js"

import "./ConfirmationOfCancellationModal.vue?vue&type=style&index=0&id=7402b8a1&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7402b8a1"]])

export default __exports__